module.exports = __webpack_public_path__ + "static/media/82 - Giorgio Moroder - In the Middle of the Knight (Remastered).437a726a.mp3";